import { useState, useRef } from 'react';
import './App.css';
import ArrimaPrincipalForm from './principalForm';
import ArrimaSpouseForm from './spouseForm';
import {
  Button,
  Box,
  Paper,
  Backdrop,
  CircularProgress,
  Divider,
  CssBaseline
} from '@mui/material';
import TalentExceptionForm from './talentExceptionForm';
import DeclarationSignature from './declarationSignature';
import StickySidebar from './sidebar';

function App() {
  const [loading, setLoading] = useState(false);
  const principalRef = useRef(null);
  const spouseRef = useRef(null);
  const talentRef = useRef(null);
  const declarationRef = useRef(null);

  const handleScrollToSection = (section) => {
    if (section === 'principal' && principalRef.current) {
      principalRef.current.scrollIntoView({ behavior: 'smooth' });
    } else if (section === 'spouse' && spouseRef.current) {
      spouseRef.current.scrollIntoView({ behavior: 'smooth' });
    } else if (section === 'talent' && talentRef.current) {
      talentRef.current.scrollIntoView({ behavior: 'smooth' });
    } else if (section === 'declaration' && declarationRef.current) {
      declarationRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const [principalForm, setPrincipalForm] = useState({
    // -------------------------------------------------
    // Personal Information
    // -------------------------------------------------
    lastNamePassport: "",
    firstNamePassport: "",
    otherNamesUsed: "",
    sex: "",
    birthDate: "",
    birthCity: "",
    birthCountry: "",
    firstCitizenship: "",
    secondCitizenship: "",
    passportNumber: "",
    passportIssuingCountry: "",
    hasMIFIReferenceNumber: "",
    mifiReferenceNumber: "",
    hasIRCCNumber: "",
    irccNumber: "",
    irccIdentificationNumber: "",

    // -------------------------------------------------
    // Contact Information
    // -------------------------------------------------
    email: "",
    residenceAddress: "",
    residenceCountry: "",
    residenceProvince: "",
    residenceCity: "",
    residencePostalCode: "",
    phoneNumber: "",

    // -------------------------------------------------
    // Family Situation
    // -------------------------------------------------
    maritalStatus: "",
    willAccompanySpouse: "",
    spouseLastName: "",
    spouseFirstName: "",
    spouseBirthDate: "",
    children: [
      {
        lastName: "",
        firstName: "",
        sex: "",
        birthDate: "",
      }
    ],

    // -------------------------------------------------
    // Current Status in Quebec
    // -------------------------------------------------
    currentQuebecStatus: "",
    currentPermitReferenceNumber: "",
    currentPermitStartDate: "",
    currentPermitEndDate: "",

    // -------------------------------------------------
    // Intentions in Quebec
    // -------------------------------------------------
    intentPermanentWorker: "",
    intendOperateControlledBusiness: "",
    employmentSectorUnacceptable: "",

    // -------------------------------------------------
    // Main Profession
    // -------------------------------------------------
    cnpCode: "",
    cnpTitle: "",
    feerCategory: "",

    // -------------------------------------------------
    // Exceptional Talent
    // -------------------------------------------------
    exceptionalTalent: "",

    // -------------------------------------------------
    // Validated Job Offer
    // -------------------------------------------------
    hasValidatedJobOffer: "",

    // -------------------------------------------------
    // Intended Place of Settlement
    // -------------------------------------------------
    intendedCity: "",
    intendedRegion: "",

    // -------------------------------------------------
    // Education – Required Questions BEFORE Array
    // -------------------------------------------------
    hasEducationAbovePrimary: "",
    hasComparativeEvaluation: "",
    integrateComparativeEvaluation: "",

    // -------------------------------------------------
    // Education Records (ARRAY)
    // -------------------------------------------------
    education: [
      {
        diploma: "",
        diplomaIssuingCountry: "",
        studiesStartDate: "",
        studiesEndDate: "",
        diplomaTitle: "",
        diplomaAuthority: "",
        educationDomain: "",
        educationField: "",
        educationSpeciality: ""
      }
    ],

    // -------------------------------------------------
    // Career – Last 5 Years (ARRAY)
    // -------------------------------------------------
    career: [
      {
        startDate: "",
        stillWorking: "",
        endDate: "",
        employmentType: "",      // full-time / part-time / internship / etc.
        jobType: "",
        title: "",
        companyName: "",
        isOwner: "",
        country: "",
        province: "",
        weeklyHours: "",
        jobTitle: ""
      }
    ],
    /*
        
    */
    // -------------------------------------------------
    // French Language Skills
    // -------------------------------------------------
    hasFrenchTest: "",
    frenchTestType: "",
    frenchCandidateNumber: "",
    frenchTestDate: "",
    frenchTestCenterName: "",
    frenchTestCenterCity: "",
    frenchTestCenterCountry: "",
    frenchSpeaking: "",
    frenchListening: "",
    frenchWriting: "",
    frenchReading: "",

    // -------------------------------------------------
    // English Language Skills
    // -------------------------------------------------
    hasEnglishTest: "",
    englishTestType: "",
    englishTestDate: "",
    englishTestNumber: "",
    englishTestCenterNumber: "",
    englishTestCountry: "",
    englishSpeaking: "",
    englishListening: "",
    englishWriting: "",
    englishReading: "",

    // -------------------------------------------------
    // Additional Information
    // -------------------------------------------------
    worksForINGO: "",
    ingoName: "",
    quebecResidenceCityOutsideCMM: "",
    quebecResidenceStartDate: "",

    // -------------------------------------------------
    // Studies in Quebec
    // -------------------------------------------------
    studiedInQuebec: "",

    // -------------------------------------------------
    // Family / Region Choice
    // -------------------------------------------------
    intendSettleOutsideCMM: "",

    // -------------------------------------------------
    // Regulated Profession
    // -------------------------------------------------
    isProfessionRegulated: "",

    // -------------------------------------------------
    // Previous Applications
    // -------------------------------------------------
    hasPendingSelectionApplication: "",
    hasMisrepresentationRefusalLast5Years: "",

    // -------------------------------------------------
    // Declaration (Signature + Date)
    // -------------------------------------------------
    declarationSignature: "",
    declarationDate: ""
  });

  const [spouseForm, setSpouseForm] = useState({
    // -------------------------------------------------
    // Spouse Personal Information
    // -------------------------------------------------
    spouseLastNamePassport: "",
    spouseFirstNamePassport: "",
    spouseOtherNamesUsed: "",
    spouseSex: "",
    spousePersonalBirthDate: "",

    spouseHasMIFIReferenceNumber: "",
    spouseMifiReferenceNumber: "",

    // -------------------------------------------------
    // Current Situation in Quebec
    // -------------------------------------------------
    spouseCurrentStatus: "",
    spousePermitNumber: "",
    spousePermitStartDate: "",
    spousePermitEndDate: "",

    // -------------------------------------------------
    // Education – Required Questions
    // -------------------------------------------------
    spouseHasEducationAbovePrimary: "",
    spouseHasComparativeEvaluation: "",

    // -------------------------------------------------
    // Education Records (ARRAY)
    // -------------------------------------------------
    spouseEducation: [
      {
        country: "",
        startDate: "",
        completionDate: "",
        officialTitle: "",
        issuingAuthority: "",
        domain: "",
        field: "",
        speciality: ""
      }
    ],

    // -------------------------------------------------
    // Work Experience in Quebec – Last 5 Years (ARRAY)
    // -------------------------------------------------
    spouseHasQuebecWorkExperience: "",
    spouseWorkExperience: [
      {
        startDate: "",
        endDate: "",
        employmentType: "",
        jobType: "",
        jobTitle: "",
        companyName: "",
        isOwner: "",
        country: "",
        province: "",
        weeklyHours: "",
        employerSectorInadmissible: ""
      }
    ],

    // -------------------------------------------------
    // French Language Skills
    // -------------------------------------------------
    spouseHasFrenchTest: "",
    spouseFrenchTestType: "",
    spouseFrenchCandidateNumber: "",
    spouseFrenchTestDate: "",
    spouseFrenchTestCenterName: "",
    spouseFrenchTestCenterCity: "",
    spouseFrenchTestCenterCountry: "",
    spouseFrenchSpeaking: "",
    spouseFrenchWriting: "",
    spouseFrenchListening: "",
    spouseFrenchReading: "",

    // -------------------------------------------------
    // Declaration (Signature + Date)
    // -------------------------------------------------
    spouseDeclarationSignature: "",
    spouseDeclarationDate: ""
  });

  const [talentFormData, setTalentFormData] = useState({
    hasRecognizedAchievement: '',
    recognizedCanadaExcellenceChair: false,
    recognizedCanadaResearchChair: false,
    recognizedUNESCOChair: false,
    recognizedInstitutionalChair: false,
    recognizedMinisterialChair: false,

    hasPositivePartnerOpinion: '',
    partnerCALQ: false,
    partnerFRQ: false,
    partnerINS: false,
    partnerMEIE: false,

    talentOpinionNumber: '',
    talentDeclarationSignature: '',
    talentDeclarationDate: ''
  });

  const handleSubmitAll = async e => {
    e.preventDefault();
    setLoading(true);
    const formData = {
      ...principalForm,
      ...(principalForm.willAccompanySpouse === "Oui" ? spouseForm : {}),
      ...(principalForm.exceptionalTalent === "Oui" ? talentFormData : {}),
    }
    try {
      const response = await fetch('https://arrima.montrealvisa.ca/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      if (!response.ok) throw new Error(`Erreur serveur: ${response.status}`);
      alert('Formulaire soumis avec succès!');
    } catch (error) {
      console.error(error);
      alert('Échec de la soumission. Veuillez réessayer.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Paper elevation={3} sx={{ p: 4, maxWidth: 600, mx: 'auto' }}>
      <CssBaseline />
      <StickySidebar setActiveSection={handleScrollToSection} principalForm={principalForm} />
      <form onSubmit={handleSubmitAll}>
        <div ref={principalRef}>
          <ArrimaPrincipalForm
            principalForm={principalForm}
            setPrincipalForm={setPrincipalForm}
          />
        </div>
        {principalForm.willAccompanySpouse === "Oui" && (
          <div ref={spouseRef}>
            <Divider sx={{ my: 3 }} />
            <ArrimaSpouseForm
              spouseForm={spouseForm}
              setSpouseForm={setSpouseForm}
            />
          </div>
        )}
        {principalForm.exceptionalTalent === "Oui" && (
          <div ref={talentRef}>
            <Divider sx={{ my: 3 }} />
            <TalentExceptionForm
              talentFormData={talentFormData}
              setTalentFormData={setTalentFormData}
            />
          </div>
        )}
        <div ref={declarationRef}>
          <Divider sx={{ my: 3 }} />
          <DeclarationSignature
            principalForm={principalForm}
            setPrincipalForm={setPrincipalForm}
          />
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4, mb: 4 }}>
            <Button
              type="submit"
              variant="contained"
              size="large"
              sx={{ px: 6, py: 2, fontSize: '1.2rem' }}
            >
              Soumettre tous les formulaires
            </Button>
          </Box>
        </div>
      </form>
      <Backdrop open={loading} sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Paper>
  );
}
export default App;

